const Footer =() => {
    return(
<h6>App designed by Hazvinei Kandawasvika of  <a href="https://www.digsoldevs.co.za/">Digsoldevs  &copy; </a> </h6>
    )
}

export default Footer;